<template>
  <page-template type="norightpanel" class="tenants">
    <template v-slot:toolbar>
        <tool-bar type="tenants" title="Locataires" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <div class="padding-x">
        <rectangular-banner
          type="sponsoring"
          title="soumission de locataire"
          textobject="vous propose"
          object="une candidature"
          textbutton="Voir la candidature"
        ></rectangular-banner>
      </div>
      <data-table
        text1="Locataires actifs: "
        number1="564"
        :headers="headers"
        :items="tenants"
      ></data-table>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import rectangularBanner from '@/components/RectangularBanner.vue'
  import dataTable from '@/components/DataTable.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Locataires',
    components: { pageTemplate, toolBar, dataTable, rectangularBanner },
    data: () => {
      return {
        headers: [
          { text: 'Nom', value: 'name' },
          { text: 'Prénom', value: 'surname' },
          { text: 'Adresse', value: 'address' },
          { text: 'Email', value: 'email' },
          { text: 'Début de bail', value: 'leasebeginning' },
          { text: 'Fin de bail', value: 'leaseending' },
          { text: 'Points', value: 'points' },
          { text: 'Document', value: 'document' }
        ],
        tenants: [
          {
            name: 'Dupont',
            surname: 'Jean',
            address: 'rue du moulin - 06000 Nice',
            email: 'jeandupont@mail.fr',
            leasebeginning: '12/12/2019',
            leaseending: '12/12/2022',
            points: '222',
            document: 'Voir le dossier'
          },
          {
            name: 'Dupont',
            surname: 'Jean',
            address: 'rue du moulin - 06000 Nice',
            email: 'jeandupont@mail.fr',
            leasebeginning: '12/12/2019',
            leaseending: '12/12/2022',
            points: '222',
            document: 'Voir le dossier'
          },
          {
            name: 'Dupont',
            surname: 'Jean',
            address: 'rue du moulin - 06000 Nice',
            email: 'jeandupont@mail.fr',
            leasebeginning: '12/12/2019',
            leaseending: '12/12/2022',
            points: '222',
            document: 'Voir le dossier'
          },
          {
            name: 'Dupont',
            surname: 'Jean',
            address: 'rue du moulin - 06000 Nice',
            email: 'jeandupont@mail.fr',
            leasebeginning: '12/12/2019',
            leaseending: '12/12/2022',
            points: '222',
            document: 'Voir le dossier'
          },
          {
            name: 'Dupont',
            surname: 'Jean',
            address: 'rue du moulin - 06000 Nice',
            email: 'jeandupont@mail.fr',
            leasebeginning: '12/12/2019',
            leaseending: '12/12/2022',
            points: '222',
            document: 'Voir le dossier'
          }
        ]
      }
    },
    async created () {
      try {
        // ALL TENANTS
        const tenantsRes = await axios.get(`${apiURL}/data/tenants`)
        this.tenants = tenantsRes.data
        // TENANT DETAIL
        const tenantDetailRes = await axios.get(`${apiURL}/data/tenant/:id`)
        this.tenantDetail = tenantDetailRes.data
        // ALL TENANT REQUESTS
        const allRequestsRes = await axios.get(`${apiURL}/data/tenant/sponsorship/all/:id`)
        this.allResquests = allRequestsRes.data
        // LAST TENANT REQUEST
        const lastRequestRes = await axios.get(`${apiURL}/data/tenant/sponsorship/last/:id`)
        this.lastResquest = lastRequestRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>